import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import { useDecodedAccessToken } from '@b-stock/fe-core/bstock-next/components'
import {
  type OrchestratedOfferingListingDetails,
  type OrchestratedAuctionListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'
import { Accordion } from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Typography } from '@b-stock/fe-core/design-system'

import {
  TableContainer,
  Title as SectionTitle,
} from '@/buyer-portal/components/features/shared'

import { ListingAttachments } from './ListingAttachments'

const DesktopAttachmentsWrapper = styled.div`
  /* Show only on desktop (large screens and above) */
  display: block;
  @media ${Breakpoints.max.medium} {
    display: none;
  }
`

const TabletMobileAccordionWrapper = styled.div`
  /* Hide on desktop - show only on tablet and mobile */
  display: none;
  @media ${Breakpoints.max.medium} {
    display: block;
  }

  /* Mobile: Style accordion labels with Title2 */
  > div > div:first-child {
    ${Typography.Title2}
  }
  @media ${Breakpoints.min.medium} and ${Breakpoints.max.medium} {
    /* Tablet: Show content normally without accordion */
    > div > div:first-child {
      display: none; /* Hide accordion header */
    }
    > div > div:last-child {
      height: auto !important;
      overflow: visible !important;
      padding: 0 !important;
    }
  }
`

export const ListingAttachmentsSection = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  const { formatMessage } = useIntl()

  const personId = useDecodedAccessToken()?.personId
  const documents = listing.lot.documents
  const title = formatMessage({ id: 'Auction.title.attachments' })

  if (!personId || !documents?.length) return null

  return (
    <>
      <DesktopAttachmentsWrapper>
        <TableContainer>
          <SectionTitle>{title}</SectionTitle>
          <div>
            <ListingAttachments documents={documents} />
          </div>
        </TableContainer>
      </DesktopAttachmentsWrapper>
      <TabletMobileAccordionWrapper>
        <Accordion label={title} isOpen>
          <ListingAttachments documents={documents} />
        </Accordion>
      </TabletMobileAccordionWrapper>
    </>
  )
}
